import {
  uniqueNamesGenerator,
  adjectives,
  animals,
} from 'unique-names-generator'

export const isEmpty = string => {
  return !string || string.length === 0
}

export function randomName() {
  return uniqueNamesGenerator({
    dictionaries: [adjectives, animals],
    style: 'capital',
    length: 2,
    separator: ' ',
  })
}

const overFirstLetter = f => string => {
  if (!string || string.length === 0) return ''
  return f(string[0]) + string.slice(1)
}

export const capitalize = overFirstLetter(l => l.toUpperCase())

export function template(templateString, templateVars, options = {}) {
  const finalOptions = {
    regex: /%{(\w+)}/g,
    ...options,
  }
  return templateString.replace(finalOptions.regex, (match, key) => {
    switch (typeof templateVars[key]) {
      case 'object':
        return JSON.stringify(templateVars[key])
      case 'function':
        return templateVars[key]()
      case 'undefined':
        // NOTE (jscheel): This is different from mobile-frontend as we want to
        // retain the template variable here, instead of clearing it.
        return match
      default:
        return templateVars[key]
    }
  })
}

export function toURL(str) {
  try {
    return new URL(str)
  } catch {
    return null
  }
}
